import React from "react";
import Card from "react-bootstrap/Card";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Isuru Amantha </span>
            from <span className="purple"> Colombo, Sri lanka.</span>
            <br />Currently working as a Senior Software Engineer. 
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
            ‣ Watching films
            </li>
            <li className="about-activity">
            ‣ Hiking and Camping
            </li>
            <li className="about-activity">
            ‣ Travelling
            </li>
            <li className="about-activity">
            ‣ Working out
            </li>
          </ul>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
